// galleryImages.js
const importAll = (requireContext) => requireContext.keys().map(requireContext);

const images = importAll(require.context('../../assets/gallery', false, /\.(png|jpe?g|svg|JPE?G)$/));

export default images;
